import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IncludeSurveyModel, SurveyCutModelCore, SurveyVersionModelCore} from '../../../../models/summary/summary.model';

@Component({
  selector: 'app-include-version',
  templateUrl: './include-version.component.html',
  styleUrls: ['./include-version.component.less']
})
export class IncludeVersionComponent implements OnInit, AfterViewInit {

  dropdown = false;
  compare = false;
  isValid = false;
  isModeChoose = false;
  isSelectedAll = false;
  isOverChooseValid = false;
  maxSelectorCanSelected = 5;
  numberOfVersionChoosed = 0;

  @Output() includeSurveyChoice: EventEmitter<any> = new EventEmitter<any>();

  @Input() listSurveyVersion: SurveyVersionModelCore[] = [];
  @Input() label: string;
  @Input() listSelectedSurveyVersionHash: string[] = [];
  @Input() listSurveyCut: SurveyCutModelCore[];
  @Input() includeSurvey: IncludeSurveyModel;
  @Input() isShowExploreCompareChartsMode: boolean;

  listSelectedSurveyCutId: number[] = [];
  checkedselectorAll = false;
  outputdselectorAll = false;
  totalChoosed = 0;

  constructor() {    
  }

  ngOnInit() {
    
  }

  ngAfterViewInit(): void {
    this.isModeChoose = this.includeSurvey.compare;
    this.checkedselectorAll = this.includeSurvey.allResponsesSelected;
    this.outputdselectorAll = this.checkedselectorAll;
    this.listSelectedSurveyVersionHash = [];
    this.listSurveyVersion.forEach(s => {
      this.listSelectedSurveyVersionHash.push(s.hash);
    });
    this.listSelectedSurveyCutId = [];
    this.listSurveyCut.forEach(s => {
      this.listSelectedSurveyCutId.push(s.id);
    });
    this.checkValidForm();
  }

  toggleDropdown() {
    this.dropdown = !this.dropdown;
    this.compare = this.isModeChoose;
    this.listSurveyVersion.forEach(s => {
      s.isSelected = this.listSelectedSurveyVersionHash.includes(s.hash);
    });
    this.listSurveyCut.forEach(s => {
      s.isSelected = this.listSelectedSurveyCutId.includes(s.id);
    });
    this.checkedselectorAll = this.outputdselectorAll;
    this.checkValidForm();
  }

  onCompareChange(event: any) {
    this.compare = event;
    if (this.compare) {
      const selectorSelected = this.listSurveyVersion.filter(s => s.isSelected);
      if (selectorSelected.length > 5) {
        this.checkedselectorAll = false;
        selectorSelected.forEach(s => s.isSelected = false);
      }
    }
    this.checkValidForm();
  }

  onSelectSurvey(event: any, survey: SurveyVersionModelCore) {
    survey.isSelected = event;
    this.checkValidForm();
  }

  onOkClicked() {
    this.isModeChoose = this.compare;
    this.includeSurveyChoice.emit({
      compare: this.isModeChoose,
      listSurveyCut: this.listSurveyCut.filter(s => s.isSelected),
      allResponsesSelected: this.checkedselectorAll,
      allVersionSelected: this.isSelectedAll,
      listSurveyVersion: this.listSurveyVersion.filter(s => s.isSelected),
      isOverChooseValid: this.isOverChooseValid
    });
    this.dropdown = false;
    this.outputdselectorAll = this.checkedselectorAll;
    this.listSelectedSurveyVersionHash = [];
    this.listSurveyVersion.filter(s => s.isSelected).forEach(s => {
      this.listSelectedSurveyVersionHash.push(s.hash);
    });
    this.listSelectedSurveyCutId = [];
    this.listSurveyCut.filter(s => s.isSelected).forEach(s => {
      this.listSelectedSurveyCutId.push(s.id);
    });
  }

  checkValidForm() {
    this.numberOfVersionChoosed = this.listSurveyVersion.filter(s => s.isSelected).length;
    const numberOfCutChoosed = this.listSurveyCut.filter(s => s.isSelected).length;

    this.isSelectedAll = this.listSurveyVersion.length > 0 && this.numberOfVersionChoosed === this.listSurveyVersion.length;

    if (this.compare) {
      this.totalChoosed = this.numberOfVersionChoosed + numberOfCutChoosed + (this.checkedselectorAll ? 1 : 0);
      this.isValid = this.totalChoosed >= 2;
      this.isOverChooseValid = this.totalChoosed > this.maxSelectorCanSelected;
    } else {
      this.isValid = this.listSurveyVersion.filter(s => s.isSelected).length >= 1;
    }
  }

  onClickOutside(event: any) {
    if (event && event['value'] === true) {
      const listExceptionalId: string[] = [
        'include-version-container',
        'include-version-div-label',
        'include-version-span-label'
      ];
      if (!listExceptionalId.includes(event.target.id)) {
        this.dropdown = false;
        this.compare = this.isModeChoose;
        this.listSurveyVersion.forEach(s => {
          s.isSelected = this.listSelectedSurveyVersionHash.includes(s.hash);
        });
        this.listSurveyCut.forEach(s => {
          s.isSelected = this.listSelectedSurveyCutId.includes(s.id);
        });
      }
    }
  }

  selectAllSurveyVersion(e: any) {
    this.listSurveyVersion.forEach(s => s.isSelected = e);
    this.checkValidForm();
  }

  onCutsSelector(event: any, cut: SurveyCutModelCore) {
    cut.isSelected = event;
    this.checkValidForm();
  }

  onCheckAllResponse(event: any) {
    this.checkedselectorAll = event;
    this.checkValidForm();
  }

  isInvalidExploreCompareChartsMode() {
    return this.compare && this.totalChoosed > 8 && this.isShowExploreCompareChartsMode;
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/master-summary/include-version/include-version.component.ts